import styled from "styled-components";
import { Flex } from "components";

export const Wrapper = styled(Flex)`
  max-width: ${({ width }) => width === "half" && "46%"};
`;
